import { render, staticRenderFns } from "./ExpandedPieChart.vue?vue&type=template&id=2ede5dd2&scoped=true&"
import script from "./ExpandedPieChart.vue?vue&type=script&lang=js&"
export * from "./ExpandedPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedPieChart.vue?vue&type=style&index=0&id=2ede5dd2&prod&lang=scss&scoped=true&"
import style1 from "./ExpandedPieChart.vue?vue&type=style&index=1&id=2ede5dd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede5dd2",
  null
  
)

export default component.exports